<c-card *transloco="let t">
    <c-card-body class="px-2">

            <c-row>
              <c-col md="12" lg="6">
                  <h1>{{ t('The Learning Center') }}</h1>
              </c-col>
              <c-col  md="12" lg="6" class="text-end">

                <div class="btn-group mb-2 " role="group">
                  <a class="btn btn-info text-white" href="https://learn.okalone.net?ul={{okService.session.token}}" target="_new" role="button"><i class="fas fa-external-link"></i> {{ t('Go to the Learning Center') }}</a>
                  <a href="https://okalone.zendesk.com/hc/en-gb/articles/35352815117969-Using-the-Learning-Center" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a>
                </div>
              </c-col>
            </c-row>

            <p>{{ t('The Learning Center helps monitors and workers understand best practices for lone working, and explains how OK Alone helps keep them safe. There are 5-7 topics and each one should take around 5 minutes to complete. Find out more about the') }} <a href="https://okalone.zendesk.com/hc/en-gb/articles/35352815117969-Using-the-Learning-Center" target="_new">{{ t('Learning Center') }} <i class="fa-solid fa-link"></i></a>.</p>

            <br/>

            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a class="nav-link" [class.active]="tab=='workers'" (click)="tab='workers'">{{ t('Worker Learning Center Summary') }}</a>
              </li>
              <li class="nav-item" [class.active]="tab=='monitors'" (click)="tab='monitors'">
                <a class="nav-link">{{ t('Monitor Learning Center Summary') }}</a>
              </li>
            </ul>
            <br/>
            <ng-container *ngIf="tab=='workers'">


                <h3>{{ t('Worker Learning Center Summary') }}</h3>
                <p>{{ t('Here is a summary of the Learning Center progress for your workers.') }}</p>


            <c-row *ngIf="workers">
              <c-col>

                <table
                [hover]="true"
                [responsive]="true"
                [striped]="true"
                align="middle"
                cTable
                class="mb-0 border"
                >
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col">{{ t('Name') }}</th>
                      <th scope="col">{{ t('Email') }} / {{ t('Phone') }}</th>
                      <th scope="col">{{ t('Link Sent') }}</th>
                      <th scope="col">{{ t('Started') }}</th>
                      <th scope="col">{{ t('Topic Progress') }}</th>
                      <th scope="col">{{ t('Completed') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let worker of workers" [class.table-success]="worker.completed != null">
                        <td>
                          <button color="info" cButton class="me-1 btn-sm text-white" (click)="sendWorkerLink(worker)">
                            <i class="far fa-paper-plane"></i>
                            {{ t('Send') }}
                          </button>
                        </td>
                        <td>
                          <span class="fs-5">{{worker.name}}</span>
                        </td>
                        <td>
                          {{worker.email}}
                          <div class="small text-medium-emphasis">
                            <span>{{worker.phone}}</span>
                          </div>
                        </td>
                        <td>
                            <span class="badge bg-success" *ngIf="worker.send_login_at"><i class="fas fa-check"></i></span>
                        </td>
                        <td>
                            <span class="badge bg-success" *ngIf="worker.started_at"><i class="fas fa-check"></i></span>
                        </td>
                        <td>
                            <span class="badge"  [ngClass]="{
                                'bg-secondary': worker.started_at == null,
                                'bg-warning': worker.completed == null && worker.started_at != null,
                                'bg-success' : worker.completed != null
                            }">
                                {{worker.pec_complete}}
                            </span>
                        </td>
                        <td>
                            <span class="badge bg-success" *ngIf="worker.completed"><i class="fas fa-check"></i></span>
                        </td>

                      </tr>
                    </tbody>

                </table>

                <br/>

                <div class="row">
                  <div class="col-12">
                    <div class="row d-flex mb-2">
                    
                      <ng-container *ngIf="okService.groups.length > 0 && okService.hasFeature('groups')">
  
                        <label  class="col-sm-3 col-form-label text-end" for="groups">
                          <b>{{ t('Filter by Groups') }}</b>
                        </label>
                        <div class="col-sm-4">
                          <ng-select
                          [items]="okService.groups"
                          name="groups"
                          [(ngModel)]="groups_filter"
                          [multiple]="true"
                          bindLabel="name"
                          bindValue="id">
                          </ng-select>
                          
                        </div>
                        <div class="col-sm-2">
                          <button class="btn btn-info text-white" (click)="groupFilter()"><i class="fas fa-search"></i> {{ t('Filter') }}</button>
                        </div>
                      </ng-container>
                    </div>
                  
  
                  </div>
                </div>


                <br/>
                <div class="row">
                  <div class="col col-md-10 col-lg-8">
                    <div class="card">
                        <div class="card-header">
                          <b>{{ t('Send Links to Workers') }}</b>
                        </div>
                        <div class="card-body">
                            <p><i class="fa-solid fa-circle-info"></i> {{ t('We will send the workers an email/SMS with a link to the learning center. They can then login and work their way through the topics.') }}</p>
                            <p *ngIf="groups_filter.length > 0">Links will be sent to workers in these groups: <b>{{groups_filter_names.join(", ")}}</b></p>
                            <button type="button" class="btn btn-info text-white" (click)="sendWorkerLinks()">
                              <span *ngIf="!loading"><i class="far fa-paper-plane"></i> {{ t('Send Links to Workers') }}</span>
                              <span *ngIf="loading"><i class="fas fa-spinner fa-spin"></i> {{ t('Send Links to Workers') }}</span>
                            </button><br/>
                            <div class="alert alert-success mt-1" role="alert" *ngIf="send_worker_info">
                              <i class="fa-solid fa-check"></i> {{send_worker_info}}
                            </div>
                        </div>
                    </div>

                  </div>
                </div>

              </c-col>
            </c-row>


            

            </ng-container>

            <ng-container *ngIf="tab=='monitors'">


                  <h2>{{ t('Monitor Learning Center Summary') }}</h2>
                  <p>{{ t('Here is a summary of the Learning Center progress for your monitors.') }}</p>


            <c-row *ngIf="monitors">
                <c-col>

                  <table
                  [hover]="true"
                  [responsive]="true"
                  [striped]="true"
                  align="middle"
                  cTable
                  class="mb-0 border"
                  >
                    <thead>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ t('Name') }}</th>
                        <th scope="col">{{ t('Email') }} / {{ t('Phone') }}</th>
                        <th scope="col">{{ t('Link Sent') }}</th>
                        <th scope="col">{{ t('Started') }}</th>
                        <th scope="col">{{ t('Topic Progress') }}</th>
                        <th scope="col">{{ t('Completed') }}</th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let monitor of monitors" [class.table-success]="monitor.completed != null">
                          <td>
                            <button color="info" cButton class="me-1 btn-sm text-white" (click)="sendMonitorLink(monitor)">
                              <i class="far fa-paper-plane"></i>
                              {{ t('Send') }}
                            </button>
                          </td>
                          <td>
                            <span class="fs-5">{{monitor.name}}</span>
                          </td>
                          <td>
                            {{monitor.email}}
                            <div class="small text-medium-emphasis">
                              <span>{{monitor.phone}}</span>
                            </div>
                          </td>
                          <td>
                              <span class="badge bg-success" *ngIf="monitor.send_login_at"><i class="fas fa-check"></i></span>
                          </td>
                          <td>
                              <span class="badge bg-success" *ngIf="monitor.started_at"><i class="fas fa-check"></i></span>
                          </td>
                          <td>
                              <span class="badge"  [ngClass]="{
                                  'bg-secondary': monitor.started_at == null,
                                  'bg-warning': monitor.completed == null && monitor.started_at != null,
                                  'bg-success' : monitor.completed != null
                              }">
                                  {{monitor.pec_complete}}
                              </span>
                          </td>
                          <td>
                              <span class="badge bg-success" *ngIf="monitor.completed"><i class="fas fa-check"></i></span>
                          </td>

                        </tr>
                      </tbody>

                  </table>

                  <br/>

                  <div class="row">
                    <div class="col-12">
                      <div class="row d-flex mb-2">
                      
                        <ng-container *ngIf="okService.groups.length > 0 && okService.hasFeature('groups')">
    
                          <label  class="col-sm-3 col-form-label text-end" for="groups">
                            <b>{{ t('Filter by Groups') }}</b>
                          </label>
                          <div class="col-sm-4">
                            <ng-select
                            [items]="okService.groups"
                            name="groups"
                            [(ngModel)]="groups_filter"
                            [multiple]="true"
                            bindLabel="name"
                            bindValue="id">
                            </ng-select>
                            
                          </div>
                          <div class="col-sm-2">
                            <button class="btn btn-info text-white" (click)="groupFilter()"><i class="fas fa-search"></i> {{ t('Filter') }}</button>
                          </div>
                        </ng-container>
                      </div>
                    
    
                    </div>
                  </div>
                  
                  <br/>
                  <div class="row">
                    <div class="col col-md-10 col-lg-8">
                      <div class="card">
                          <div class="card-header">
                            <b>{{ t('Send Links to Monitors') }}</b>
                          </div>
                          <div class="card-body">
                              <p><i class="fa-solid fa-circle-info"></i> {{ t('We will send the monitors an email/SMS with a link to the learning center. They can then login and work their way through the topics.') }}</p>
                              <p *ngIf="groups_filter.length > 0">Links will be sent to monitors in these groups: <b>{{groups_filter_names.join(", ")}}</b></p>
                              <button type="button" class="btn btn-info text-white" (click)="sendMonitorLinks()">
                                <span *ngIf="!loading"><i class="far fa-paper-plane"></i> {{ t('Send Links to Monitors') }}</span>
                                <span *ngIf="loading"><i class="fas fa-spinner fa-spin"></i> {{ t('Send Links to Monitors') }}</span>
                              </button><br/>
                              <div class="alert alert-success mt-1" role="alert" *ngIf="send_monitor_info">
                                <i class="fa-solid fa-check"></i> {{send_monitor_info}}
                              </div>
                          </div>
                      </div>
                    </div>
                  </div>

                </c-col>
              </c-row>
            </ng-container>



            <br/><br/>


    </c-card-body>
  </c-card>
